import React from "react";
import { Row } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";
import debounce from "lodash.debounce";
import { PlaylistsPage } from "./PlaylistsPage";
import { PlaylistsSidebar } from "./components"
import { PlaylistPage } from "./PlaylistPage";
import { NavigationHelper } from "../helpers";
import { AccountWarnings } from "../components/AccountWarnings";

export const PlaylistsRouter: React.FC = () => {
  const location = useLocation();
  const [refreshKey, setRefreshKey] = React.useState("");

  React.useEffect(NavigationHelper.hideMobileSidebar, [location.pathname]) // eslint-disable-line

  // Debounced refresh function - prevents excessive sidebar re-renders
  const refreshSidebar = React.useMemo(
    () => debounce(() => {
      setRefreshKey(NavigationHelper.getRefreshKey());
    }, 300),
    []
  );


  return (
    <>
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <Row>
        <nav className="col-sm-3 col-md-2 d-none d-md-block bg-dark sidebar" id="sidebar">
          <PlaylistsSidebar refreshKey={refreshKey} />
        </nav>
        <main role="main" className="col-sm-12 ml-sm-auto col-md-10 pt-3">
          <AccountWarnings />
          <Routes>
            <Route path="/:id" element={<PlaylistPage refreshSidebar={refreshSidebar} />} />
            <Route path="/" element={<PlaylistsPage />} />
          </Routes>
        </main>
      </Row>
    </>
  );
};